import { render } from "./ExternalLinks.vue?vue&type=template&id=5afe047a&ts=true"
import script from "./ExternalLinks.vue?vue&type=script&lang=ts"
export * from "./ExternalLinks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__